import React, { useEffect, Suspense, lazy } from 'react';
import { initPixel, trackPageView, trackAddToCart } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { AgitationSection } from './components/AgitationSection';
import { PainGrid } from './components/PainGrid';
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const OfferCard = lazy(() => import('./components/OfferCard').then(m => ({
  default: m.OfferCard
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSectionBottom = lazy(() => import('./components/TestimonialsSectionBottom').then(m => ({
  default: m.TestimonialsSectionBottom
})));
const TwoPathsSection = lazy(() => import('./components/TwoPathsSection').then(m => ({
  default: m.TwoPathsSection
})));
const FinalCtaSection = lazy(() => import('./components/FinalCtaSection').then(m => ({
  default: m.FinalCtaSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SalesPop = lazy(() => import('./components/SalesPop').then(m => ({
  default: m.SalesPop
})));
export function App() {
  useEffect(() => {
    // Init pixel and track page view
    // Resource hints (preconnect, preload, fonts) are in index.tsx at module level
    initPixel();
    trackPageView();
  }, []);
  const handleScrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (!offerSection) return;
    const targetY = offerSection.getBoundingClientRect().top + window.scrollY - 20;
    const startY = window.scrollY;
    const distance = targetY - startY;
    const duration = 2800; // ms — lento para que el usuario vea el contenido
    let startTime: number | null = null;
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  };
  const handleCartRedirect = () => {
    trackAddToCart();
    window.location.href = 'https://www.zentori.cl/cart/50438059032822:1';
  };
  return <div className="min-h-screen bg-pure-white font-sans selection:bg-pistachio selection:text-slate-dark pt-[68px] md:pt-[60px]" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main className="overflow-hidden" data-id="element-2">
        <HeroSection onCtaClick={handleScrollToOffer} data-id="element-3" />
        <AgitationSection data-id="element-4" />
        <PainGrid data-id="element-5" />
        <Suspense fallback={null} data-id="element-6">
          <MethodSection data-id="element-7" />
          <TestimonialsSection data-id="element-8" />

          <div id="offer-section" data-id="element-9">
            <OfferCard onCtaClick={handleCartRedirect} data-id="element-10" />
          </div>

          <GuaranteeSection data-id="element-11" />
          <TestimonialsSectionBottom data-id="element-12" />
          <TwoPathsSection data-id="element-13" />
          <FinalCtaSection data-id="element-14" />
          <FaqSection data-id="element-15" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-16">
        <FooterSection data-id="element-17" />
        <SalesPop data-id="element-18" />
      </Suspense>
    </div>;
}